<template>
  <v-menu
    v-model="menu"
    min-width="18rem"
    offset-y
    transition="scale-transition"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dateInput"
        v-mask="'##-##-####'"
        :rules="[...rules, maxNumberLength(8)]"
        v-bind="$attrs"
        @blur="setDate($event)"
      >
        <template
          slot="prepend"
        >
          <v-icon
            @click="on.click($event)"
          >
            mdi-calendar-blank
          </v-icon>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      v-model="datePicker"
      no-title
      locale="pt-BR"
      @input="menu=false"
    />
  </v-menu>
</template>

<script>
import RulesMixin from 'Arch/mixins/RulesMixin';
import DateMixin from 'Arch/mixins/DateMixin';

export default {
  name: 'InputDate',
  mixins: [RulesMixin, DateMixin],
  props: {
    value: {
      type: [Date, String],
      default: '',
    },
    rules: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data: () => ({
    menu: false,
  }),
  computed: {
    date: {
      get() {
        if (this.onlyNumbers(this.value).length >= 8) {
          return this.formatDate(
            this.value,
          );
        }
        return '';
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    datePicker: {
      get() {
        const regex = /^\d{4}-\d{2}-\d{2}$/m;
        if (regex.exec(this.date) === null) {
          return null;
        }
        return this.date;
      },
      set(value) {
        if (value) {
          this.handleDate(
            this.formatDate(
              value,
              'DD-MM-YYYY',
            ),
          );
        }
      },
    },
    dateInput: {
      get() {
        return this.formatDate(
          this.date,
          'DD-MM-YYYY',
        );
      },
      set(value) {
        return value;
      },
    },
  },
  methods: {
    onlyNumbers(date) {
      return String(date)
        .replace(/[^0-9]/g, '');
    },
    makeDate(value) {
      return String(value).replace(
        /(\d{2})(\d{2})(\d{4})/,
        '$3-$2-$1',
      );
    },
    setDate(ev) {
      const { value } = ev.target;
      this.handleDate(value);
    },
    handleDate(value) {
      const dateNumbers = this.onlyNumbers(value);
      if (dateNumbers.length >= 8) {
        const formatDate = this.formatDate(
          this.makeDate(dateNumbers),
        );
        if (this.date !== formatDate) {
          this.date = formatDate;
        }
      }
    },
  },
};
</script>

<style>

</style>
